module.exports = __webpack_public_path__ + "static/media/gTech.54411e28.png";